export enum GymTags {
  'CRUNCH' = 'crunch',
}

export const GymTagToId = {
  [GymTags.CRUNCH]: 1,
};